import { createEntityAdapter } from '@reduxjs/toolkit';

import type { ILessonSection } from '@/Module/Lesson/Model/DataModel';

export const lessonSectionAdapter = createEntityAdapter<ILessonSection>({
  selectId: model => model.id,
  // sortComparer: (a, b) => (a?.sortOrder ?? 0) - (b?.sortOrder ?? 0),
});
